import { Button, Flex, HStack, IconButton, Input, InputGroup, InputLeftElement, InputRightElement, Spacer, Text, } from "@chakra-ui/react";
import React from "react";
import { FiLock, FiPlay, FiUnlock } from "react-icons/fi";
import { GiHorizontalFlip, GiVerticalFlip } from "react-icons/gi";
export const HeaderToolbar = ({ width, height, onWidthChange, onHeightChange, isLocked, onChangeLock, noAnimation, showAnimations, handleAnimationPlay, }) => {
    return (React.createElement(Flex, { direction: "row", justifyContent: "space-between", width: "100%", gap: 2 },
        React.createElement(HStack, { gap: 2 },
            React.createElement(IconButton, { onClick: () => {
                    onChangeLock(!isLocked);
                }, icon: isLocked ? React.createElement(FiLock, null) : React.createElement(FiUnlock, null), "aria-label": "V\u00E9rouiller les zones" }),
            React.createElement(Text, null, "Ecran"),
            React.createElement(HStack, null,
                React.createElement(InputGroup, { maxW: "160px" },
                    React.createElement(InputLeftElement, { pointerEvents: "none", children: React.createElement(GiHorizontalFlip, null), color: "gray.500" }),
                    React.createElement(Input, { type: "number", defaultValue: width, onKeyUp: (e) => {
                            if (e.key === "Enter") {
                                onWidthChange(parseInt(e.currentTarget.value));
                            }
                        }, onBlur: (e) => onWidthChange(parseInt(e.currentTarget.value)), bg: "white" }),
                    React.createElement(InputRightElement, { pointerEvents: "none", children: "px", color: "gray.500" })),
                React.createElement(Text, { color: "gray.500" }, "X"),
                React.createElement(InputGroup, { maxW: "160px" },
                    React.createElement(InputLeftElement, { pointerEvents: "none", children: React.createElement(GiVerticalFlip, null), color: "gray.500" }),
                    React.createElement(Input, { type: "number", defaultValue: height, onKeyUp: (e) => {
                            if (e.key === "Enter") {
                                onHeightChange(parseInt(e.currentTarget.value));
                            }
                        }, onBlur: (e) => onHeightChange(parseInt(e.currentTarget.value)), bg: "white" }),
                    React.createElement(InputRightElement, { pointerEvents: "none", children: "px", color: "gray.500" })),
                React.createElement(Spacer, null))),
        React.createElement(Button, { disabled: showAnimations || noAnimation, onClick: handleAnimationPlay, leftIcon: React.createElement(FiPlay, null), variant: "outline", borderWidth: 1, borderColor: "orange.400", color: "orange.400", sx: {
                svg: {
                    color: "orange.400",
                    fill: "orange.400",
                },
                "&:hover": {
                    backgroundColor: "orange.50",
                },
            } }, "Animations")));
};
